import { createStore, applyMiddleware } from "redux"
import { persistStore } from "redux-persist"
import thunk from "redux-thunk"
import rootReducer from "./reducers"
import { composeWithDevTools } from "redux-devtools-extension"
import { useMemo } from "react"

let store
let persistor

const initialState = {}

function initStore(preloadedState = initialState) {
  const createdStore = createStore(
    rootReducer,
    preloadedState,
    composeWithDevTools(applyMiddleware(thunk))
  )

  const createdPersistor = persistStore(createdStore)

  return { store: createdStore, persistor: createdPersistor }
}

export const initializeStore = (preloadedState) => {
  let _store = store ?? initStore(preloadedState).store
  let _persistor = persistor ?? initStore(preloadedState).persistor

  if (preloadedState && store) {
    const { store: newStore, persistor: newPersistor } = initStore({
      ...store.getState(),
      ...preloadedState,
    })
    _store = newStore
    _persistor = newPersistor
    store = undefined
    persistor = undefined
  }

  if (typeof window === "undefined")
    return { store: _store, persistor: _persistor }
  if (!store) {
    store = _store
    persistor = _persistor
  }
  return { store: _store, persistor: _persistor }
}

export function useStore(initialState) {
  const { store } = useMemo(() => initializeStore(initialState), [initialState])
  return store
}

export function usePersistor(initialState) {
  const { persistor } = useMemo(
    () => initializeStore(initialState),
    [initialState]
  )
  return persistor
}
